<template>
  <Popup v-model="show" @open="open" position="bottom" @close="cancel">
    <div class="select-content">
      <div class="select-header">
        <div class="title">{{ selectTitle }}</div>
      </div>
      <van-field
        @input="input"
        @focus="focus"
        v-if="selectTitle === 'E-Wallet/Bank Name'"
        right-icon="search"
        class="input"
        v-model="inputValue"
        placeholder="Search Bank"
      />
      <div class="list" v-if="nowColumns.length" :class="{ showSearch }">
        <div
          class="list-item"
          :class="activeIndex == index ? 'active' : ''"
          v-for="(item, index) in nowColumns"
          :key="item.label"
          @click="getResult(item)"
        >
          <p>{{ item.label }}</p>
        </div>
      </div>
    </div>
  </Popup>
</template>
<script>
import { Popup } from 'vant'
export default {
  name: 'CommonSearchPicker',
  components: {
    Popup
  },
  props: {
    value: { type: Boolean, default: false },
    defaultIndex: { type: [String, Number], default: 0 },
    columns: {
      type: Array,
      default: function () {
        return []
      }
    },
    activeIndex: {
      type: Number,
      default: undefined
    },
    loading: { type: Boolean, default: true },
    showSearch: { type: Boolean, default: false },
    selectTitle: { type: String, default: 'selectTitle' }
  },
  data () {
    return {
      inputValue: '',
      nowColumns: []
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  },
  watch: {
    columns: {
      // console.log(columns, 'columnscolumns');
      immediate: true,
      handler () {
        this.$set(this, 'nowColumns', this.columns)
      }
    },
    inputValue (e) {
      this.input(e)
    }
  },
  methods: {
    toggleShowSearch () {
      this.$emit('toggle-search', true) // 或者 false，根据需要切换
    },
    open () {
      this.$nextTick(() => {
        this.nowColumns = this.columns
        const docume = document.querySelector('.active')
        console.log(this.activeIndex, 'activeIndex')
        console.log(docume, 'docume')
        if (docume) {
          docume.scrollIntoView({ behavior: 'smooth' })
        } else {
          console.log('没有找到 active 元素')
        }
      })
    },
    getResult (item) {
      this.$emit('getResult', item)
    },
    confirm (value, index) {
      this.$emit('change', value)
      this.show = false
      this.inputValue = ''
    },
    cancel () {
      this.show = false
      this.inputValue = ''
      this.$emit('close')
    },
    input (v) {
      this.$set(
        this,
        'nowColumns',
        this.columns.filter((item) => item.label.indexOf(v.toUpperCase()) > -1)
      )
    },
    change () {},
    focus () {
      this.$emit('focus')
    }
  }
}
</script>
<style scoped lang="less">
.van-popup {
  width: 100%;
  background-color: transparent;
}
.select-content {
  padding: 18px;
  background: #ffffff;
  border-radius: 22px 22px 0px 0px;
  min-height: 240px;
  .select-header {
    margin-bottom: 10px;
    .title {
      font-weight: 500;
      font-size: 16px;
      color: #12033a;
    }
    img {
      width: 22px;
    }
  }
}
.showSearch {
  height: 250px !important;
}
.list {
  max-height: 250px;
  overflow: scroll;
  font-size: 16px;
  .list-item {
    min-height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #f2f2f2;
    font-family: Inter 18pt, Inter 18pt;
    font-weight: 400;
    font-size: 16px;
    color: #949494;
    max-width: 100%;
    p {
      width: 240px;
      white-space: normal;
      overflow-wrap: break-word;
      word-break: break-word;
    }
  }
  :last-child {
    border: none;
  }
}
.active {
  color: #0c8027 !important;
  font-weight: 500 !important;
  position: relative;
  &:before {
    content: "";
    width: 15px;
    height: 12px;
    display: inline-block;
    background-image: url("../assets/pickerTrue.png");
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    right: 0.6rem;
  }
}
.input {
  background: #f6f6f6;
  border-radius: 8px;
  border: 1px solid #c4c4c4;
  margin-bottom: 15px;
  margin-top: 20px;
  padding: 8px 12px;
}
.van-icon-search {
  font-size: 20px;
}
</style>
